import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "default_card large" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    headers: _ctx.headers,
                    items: _ctx.items,
                    page: _ctx.pagination.page,
                    "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.page) = $event)),
                    "sort-by": _ctx.pagination.sortBy,
                    "onUpdate:sortBy": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination.sortBy) = $event)),
                    "items-per-page": _ctx.pagination.rowsPerPage,
                    "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                    loading: _ctx.loading,
                    "items-length": _ctx.tagCount,
                    class: "table",
                    "fixed-header": "",
                    "max-height": "60vh"
                  }, {
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.name), 1),
                        _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.shortName), 1),
                        _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.type), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "loading", "items-length"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}